export const PAGE_TITLE = "Support";

export const PAGE_TEXT =
  "We're here to help you succeed every step of the way! Whether you're a prospective student, current trainee, or graduate, the <b>Institute of Interpersonal Hypnotherapy (IIH)</b> and <b>International Association of Interpersonal Hypnotherapists (IAIH)</b>, along with <b>IGE Business Networking Groups</b>, offer extensive support to help you achieve your goals.";

export const VIDEO_URL =
  "https://drive.google.com/file/d/1HlbOpxLKSOoy5lVS4AqJ9hrUyy5jvsY9/preview";

export const SECTION_TITLE_MAIN = "How We Can Help";

/** Section titles shown after card at given 0-based index */
export const SECTION_TITLE_AFTER_INDEX = {
  2: "Want Private Sessions?",
  5: "Networking Opportunities",
  8: "Marketing and Advertising",
};

export const SUPPORT_DATA = [
  {
    id: 1,
    title: "For Prospective Students",
    text: "<b>Thinking about IIH Training?</b?",
    text2: "To connect with an Admissions Representative.",
    link: "https://bookme.name/IIHADmissions",
    height: "200px",
  },
  {
    id: 2,
    title: "For Current Students",
    text: "<b>Need help with your training?</b>",
    text2: "Contact the Student Services Department.",
    link: "mailto:support@mynirva.com",
    height: "200px",
  },
  {
    id: 3,
    title: "Need Mentoring?",
    text: "<b>Connect with an IIH Mentor</b>",
    text2:
      "For guidance from experienced mentors through the Hypnotherapy Training Programs.",
    link: "mailto:support@mynirva.com",
    height: "200px",
  },
  {
    id: 4,
    title: "Session Exchange",
    text: "Access private hypnotherapy sessions through IGE Networking Groups.",
    redirect: true,
    tab: "exchange",
  },
  {
    id: 5,
    title: "IAIH Directory",
    text: "Find practitioners through the IAIH online directory.",
  },
  {
    id: 6,
    title: "IPHC Clinic Directory",
    text: "Locate qualified practitioners through the Interpersonal Hypnotherapy Clinics.",
  },
  {
    id: 7,
    title: "Practice Hypnotherapy",
    text: "Join student practice groups to refine your skills.",
  },
  {
    id: 8,
    title: "IGE Business Networking Groups",
    text: "Coming soon.",
  },
  {
    id: 9,
    title: "IAIH Annual Conferences",
    text: "Participate in events to expand your expertise and connections.",
    link: "https://www.instituteofhypnotherapy.com/iaih-2025-conference-landing-page/",
  },
  {
    id: 10,
    title: "Hypnotherapy Accelerator",
    text: "To learn about discounted website design and marketing services to build your practice.",

    size: 12,
    link: "https://www.instituteofhypnotherapy.com/hypnotherapy-accelerator/",
  },
  // {
  //   id: 11,
  //   title: "Empowered Path Support Groups",
  //   text: "Seven-week courses led by IIH graduate and Licensed Mental Health Counselor, <b>Natalia Manzano</b>, to help overcome limiting beliefs and self-sabotage.",
  //   size: 6,
  // },
  // {
  //   id: 12,
  //   title: "Anything Else",
  //   text: "Not sure how we can help? For personalized guidance.",
  //   size: 6,
  //   linkBox: true,
  // },
];
